// src/features/inventory/pages/SupplierDetailPage/tabs/Details/index.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography } from '@mui/material';
import {
  AlternateEmail as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as AddressIcon,
  CalendarToday as CalendarIcon,
  ContactMail as ContactIcon,
} from '@mui/icons-material';
import SectionHeader from '../../../../../../components/common/SectionHeader';

function InfoRow({ icon, label, value }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, py: 1.5 }}>
      <Box sx={{ color: 'text.secondary', mt: 0.25, flexShrink: 0 }}>{icon}</Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary" display="block">
          {label}
        </Typography>
        <Typography variant="body2" color={value ? 'text.primary' : 'text.disabled'}>
          {value ?? '—'}
        </Typography>
      </Box>
    </Box>
  );
}

function formatAddress(address) {
  if (!address) return null;
  const parts = [address.address_line1];
  if (address.address_line2) parts.push(address.address_line2);
  parts.push(`${address.postal_code} ${address.city}`);
  parts.push(address.country);
  return parts.join(', ');
}

export default function Details({ supplier }) {
  const { t } = useTranslation(['inventory', 'common']);

  const createdAt = supplier.created_at
    ? new Date(supplier.created_at).toLocaleDateString()
    : null;

  return (
    <Box sx={{ p: 3, maxWidth: 600 }}>
      <SectionHeader icon={ContactIcon} title={t('inventory:suppliers.detail.tabs.details.contact_section')} />

      <InfoRow
        icon={<EmailIcon fontSize="small" />}
        label={t('inventory:suppliers.create_form.email')}
        value={supplier.contact_email}
      />
      <InfoRow
        icon={<PhoneIcon fontSize="small" />}
        label={t('inventory:suppliers.create_form.phone')}
        value={supplier.contact_phone}
      />
      <InfoRow
        icon={<AddressIcon fontSize="small" />}
        label={t('inventory:suppliers.create_form.address_section')}
        value={formatAddress(supplier.address)}
      />

      <Divider sx={{ my: 2 }} />

      <InfoRow
        icon={<CalendarIcon fontSize="small" />}
        label={t('inventory:suppliers.detail.added')}
        value={createdAt}
      />
    </Box>
  );
}
